import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleCarousel from './components/ArticleCarousel';
import SafetySection from './components/SafetySection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';
import { siteConfig, faqData } from '@/mocks/siteConfig';

const siteDomain = 'https://superbuyspread.lat';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteConfig.siteName,
  url: siteDomain,
  description: siteConfig.description,
  inLanguage: 'en',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteDomain}/?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteConfig.siteName,
  url: siteDomain,
  description: siteConfig.tagline,
  sameAs: [siteConfig.mainSiteUrl],
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqData.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export default function Home() {
  return (
    <main>
      <JsonLd data={websiteJsonLd} />
      <JsonLd data={organizationJsonLd} />
      <JsonLd data={faqJsonLd} />
      <Navbar />
      <Hero />

      <article>
        <AboutSection />
      </article>

      <section id="categories">
        <CategoryGrid />
      </section>

      <section>
        <FeaturesSection />
      </section>

      <section>
        <ArticleCarousel />
      </section>

      <section>
        <SafetySection />
      </section>

      <section>
        <FAQSection />
      </section>

      <section>
        <CTASection />
      </section>

      <Footer />
    </main>
  );
}